<template>
  <v-dialog
      scrollable
      v-model="value"
      :max-width="dynamicMaxWidth"
      :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">审核历史</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <p v-if="!history || history.length <= 0">无审核记录</p>
        <v-list v-else three-line>
          <template v-for="(it, idx) in history">
            <v-list-tile
                :key="it.dbid"
                avatar
                ripple
            >
              <v-list-tile-avatar style="min-width: 80px; max-width: 120px;">
                <v-chip label small style="
                  white-space: normal; <!-- 允许换行 -->
                  word-break: break-word; <!-- 长单词换行 -->
                  height: auto; <!-- 高度自适应 -->
                  min-height: 32px; <!-- 最小高度 -->
                  padding: 0 8px; <!-- 调整内边距 -->
                  display: inline-flex;
                  align-items: center;" :color="statusMap[it.statusId].color"
                >
                  {{ statusMap[it.statusId].name }}
                </v-chip>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  {{ it.userName }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title class="history-note">{{ it.note || '[未填写]' }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>{{ it.timestamp.substring(0,19).replace('T', ' ') }}</v-list-tile-action-text>
              </v-list-tile-action>

            </v-list-tile>
            <v-divider
                v-if="idx + 1 < history.length"
                :key="idx"
            />
          </template>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="$emit('input', false)">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AgmtHistory",
  props: ['value', 'history', 'status', 'uri'],

  data() {
    return {
      loading: false,
      statusMap: {},
      dynamicMaxWidth: "600px",
    }
  },

  watch: {
    status(val) {
      this.statusMap = {};
      (val || []).forEach(v => {
        this.statusMap[v.identifier] = v
      });
    },

    //如果审核记录较长，则动态调整审核记录显示卡片的宽度，以便可以显示较长内容的审核意见，但也仅限于90个汉字
    history() {
      if(this.hasLongNote)
      {
        this.dynamicMaxWidth = "1300px"
      }
      else
      {
        this.dynamicMaxWidth = "600px"
      }
    }
  },

  computed:{
    //根据中医大需求新增代码，如果审核记录较长，则动态调整审核记录显示卡片的宽度，以便可以显示较长内容的审核意见，但也仅限于90个汉字
    hasLongNote: function() {
      return this.history.some(function (item) {
        return item.note && item.note.length > 50;
      });
    }
  },


  methods: {}
}
</script>

<style scoped>
/* 覆盖 Vuetify 默认的 sub-title 样式，允许换行 */
>>> .history-note {
  white-space: normal !important;
  word-break: break-word !important;
  overflow: visible !important;
  line-height: 1.4;
}
</style>